<template>
    <div>
       <md-empty-state
      md-icon="error"
      md-label="Access Denied"
      md-description="We are sorry, you do not have permission to view the request content.">
    </md-empty-state>
    </div>
</template>

<script>
  export default {
    name: 'page_access_denied'
  }
</script>
